import dynamic from 'next/dynamic';

export const MerchandisingHeroBanner = dynamic(() =>
  import('./componentsWithDCAProvider').then(mod => mod.MerchandisingHeroBanner)
);
export const MerchandisingSmallBanner = dynamic(() =>
  import('./componentsWithDCAProvider').then(mod => mod.MerchandisingSmallBanner)
);

export const MerchandisingTileSkinny = dynamic(() =>
  import('./componentsWithDCAProvider').then(mod => mod.MerchandisingTileSkinny)
);

export const MerchandisingTileSkinnyNonEditable = dynamic(() =>
  import('./componentsWithDCAProvider').then(mod => mod.MerchandisingTileSkinnyNonEditable)
);

/**
 * this is non editable component, and will use in shop - AEM author
 */
export const MerchandisingSmallBannerComp = dynamic(() =>
  import('./componentsWithDCAProvider').then(mod => mod.MerchandisingSmallBannerNonEditable)
);

export const MerchandisingCardTile = dynamic(() =>
  import('./componentsWithDCAProvider').then(mod => mod.MerchandisingCardTile)
);

export const MerchandisingCardTileNonEditable = dynamic(() =>
  import('./componentsWithDCAProvider').then(mod => mod.MerchandisingCardTileNonEditable)
);

export const MerchandisingSerpBannerComp = dynamic(() =>
  import('./componentsWithDCAProvider').then(mod => mod.MerchandisingSerpBanner)
);

export const MerchandisingSerpBannerNonEditable = dynamic(() =>
  import('./componentsWithDCAProvider').then(mod => mod.MerchandisingSerpBannerNonEditable)
);

export const MerchandisingCarouselContainer = dynamic(() =>
  import('./organisms/MerchandisingCarouselContainer').then(mod => mod.MerchandisingCarouselContainer)
);

export const MerchandisingCarouselContainerNonEditable = dynamic(() =>
  import('./organisms/MerchandisingCarouselContainer').then(mod => mod.MerchandisingCarouselContainerNonEditable)
);
export const MerchandisingPortalModalComp = dynamic(() =>
  import('./componentsWithDCAProvider').then(mod => mod.MerchandisingPortalModal)
);

export const MerchandisingPortalModalNonEditable = dynamic(() =>
  import('./componentsWithDCAProvider').then(mod => mod.MerchandisingPortalModalNonEditable)
);
